export const en = {
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday'
};
